import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

export interface AdminV2MessagingTemplatePublishedForm {
  kind: "published-form";
  id: string;
  versionId: string;
  organisationId: string | null;
  slug: string;
  title: string;
  questions: Array<{ key: string; label: string }>;
  /** Resource reference; the server produces recipient-private delivery links. */
  url: string;
}
export interface AdminV2MessagingTemplateFormOptionsResponse {
  forms: AdminV2MessagingTemplatePublishedForm[];
  pagination: { limit: number; offset: number; hasMore: boolean };
}
export interface AdminV2MessagingTemplateFormOptionsQuery {
  templateId: string;
  /** Cache partition only; never sent as request authority. */
  ownerKey?: string;
  q?: string;
  limit?: number;
  offset?: number;
}
/** The server derives organisation scope from the template and caller access. */
export const buildAdminV2MessagingTemplateFormEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2MessagingTemplateFormOptions: builder.query<
    AdminV2MessagingTemplateFormOptionsResponse,
    AdminV2MessagingTemplateFormOptionsQuery
  >({
    query: ({ templateId, q, limit, offset }) => ({
      url: `/admin/v2/messaging/templates/${encodeURIComponent(templateId)}/form-options`,
      params: { q, limit, offset },
    }),
    keepUnusedDataFor: 0,
  }),
});
